/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControllerStatus } from './ControllerStatus';
import {
    ControllerStatusFromJSON,
    ControllerStatusFromJSONTyped,
    ControllerStatusToJSON,
} from './ControllerStatus';

/**
 * 
 * @export
 * @interface Controller
 */
export interface Controller {
    /**
     * 
     * @type {string}
     * @memberof Controller
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof Controller
     */
    readonly name: string;
    /**
     * Set to "Pending creation" if this controller has not yet been created. This only makes sense when "deployment management" is set to "Auto".
     * 
     * * `pending` - Pending creation
     * * `ready` - Ready
     * @type {ControllerStatus}
     * @memberof Controller
     */
    readonly status: ControllerStatus;
    /**
     * 
     * @type {string}
     * @memberof Controller
     */
    readonly guiUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Controller
     */
    readonly loginUrl: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Controller
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Controller
     */
    readonly attentionRequired: boolean;
}

/**
 * Check if a given object implements the Controller interface.
 */
export function instanceOfController(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "guiUrl" in value;
    isInstance = isInstance && "loginUrl" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "attentionRequired" in value;

    return isInstance;
}

export function ControllerFromJSON(json: any): Controller {
    return ControllerFromJSONTyped(json, false);
}

export function ControllerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Controller {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': ControllerStatusFromJSON(json['status']),
        'guiUrl': json['gui_url'],
        'loginUrl': json['login_url'],
        'createdAt': (new Date(json['created_at'])),
        'attentionRequired': json['attention_required'],
    };
}

export function ControllerToJSON(value?: Controller | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

